var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("survey.currentSurveyResults")))]),_vm._l((_vm.sections),function(section){return _c('SurveySectionCard',{key:section.id,attrs:{"section":section,"survey":_vm.survey}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }